import * as types from '../../action-types';
import AxiosCall from '../../../utils/axios';
import ErrorHandler from '../../../utils/error-handler';

export const getHansaAccountFail = payload => ({
  type: types.GET_HANSA_ACCOUNT_FAIL,
  payload
});

export const getHansaAccountSuccess = payload => ({
  type: types.GET_HANSA_ACCOUNT_SUCCESS,
  payload
});

export const getHansaAccount = payload => async dispatch => {
  try {    
    const requestObj = {
      path: "withhansa/get_account",
      method: "POST",
      data: payload
    }
    const data  = await AxiosCall(requestObj);  
    
    console.log('MRA getHansaAccount data:', data); 

    if(data && data.error)  {        
        dispatch(getHansaAccountFail(data.message));
    }else{
        console.log('MRA getHansaAccount 1'); 
        dispatch(getHansaAccountSuccess(data));
    }
    
  } catch (err) {
    const error = ErrorHandler(err);
    console.log('MRA getHansaAccount error:', error);  
    dispatch(getHansaAccountFail(error));
  }
}
